import { useContext } from 'react'
import { JunctionContext } from '../context'

const useJunctionId = () => {
  const { junctionId, setJunctionId } = useContext(JunctionContext)
  const { junctionName, setJunctionName } = useContext(JunctionContext)

  const handleJunctionId = (junction) => {
    setJunctionId(junction.id)
    setJunctionName(junction.title)
    window.localStorage.setItem(
      process.env.REACT_APP_XITS_JUNCTION_ID,
      junction.id
    )
    window.localStorage.setItem(
      process.env.REACT_APP_XITS_JUNCTION_NAME,
      junction.title
    )
  }

  return { junctionId, handleJunctionId, junctionName }
}

export default useJunctionId
